import { usePrismicLayout } from '@prismic/context';
import { PrismicContactsQuery } from '@prismic/gqlTypes/prismicOperations';

import { NextPage } from 'next';
import { NextSeo, NextSeoProps } from 'next-seo';

import React from 'react';

import Page from './Page';

export interface ViewProps {
  contacts: PrismicContactsQuery['contacts'] | null;
  seo: NextSeoProps | null;
}

const View: NextPage<ViewProps> = ({ contacts, seo }) => {
  const { layout } = usePrismicLayout();

  return (
    <>
      <NextSeo {...seo} />
      <Page contacts={contacts} layout={layout} />
    </>
  );
};

View.displayName = 'ContactsView';

export default View;
